import { useContext } from "react";
import { AccessorTreeStateContext } from "./AccessorTreeStateContext.js";
import { BindingError } from "../BindingError.js";
const useAccessorTreeState = () => {
  const state = useContext(AccessorTreeStateContext);
  if (!state) {
    throw new BindingError();
  }
  return state;
};
export {
  useAccessorTreeState
};
//# sourceMappingURL=useAccessorTreeState.js.map
